import { render } from "./CandidateInfoCard.vue?vue&type=template&id=09e35def&scoped=true"
import script from "./CandidateInfoCard.vue?vue&type=script&lang=js"
export * from "./CandidateInfoCard.vue?vue&type=script&lang=js"

import "./CandidateInfoCard.vue?vue&type=style&index=0&id=09e35def&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e35def"]])

export default __exports__